/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { transactionsGetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGet } from "../../funcs/transactionsGetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$inboundSchema,
};

export const tool$transactionsGetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGet:
  ToolDefinition<typeof args> = {
    name: "transaction-get-v1",
    description: `Original tool name: transactions-get-tansaction-api-v1-ledgers-ledger-canister-id-transactions-index-get

Get transaction

### How is data retrieved for this endpoint?

Values from the endpoint are retrieved by scraping the transactions from the
ledger canister (and associated archive canisters).`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await transactionsGetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };